import { render, staticRenderFns } from "./Toggle-Theme.vue?vue&type=template&id=1113734c&"
import script from "./Toggle-Theme.vue?vue&type=script&lang=js&"
export * from "./Toggle-Theme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports